export enum RouteNames {
    BASE = '',
    START = 'start',
    REGISTRATION = 'registration',
    REGISTRIERUNG = 'registrierung',

    // Kredit Portal paths
    KREDIT_PORTAL = 'kreditportal',

    KUNDENAUSWAHL = 'kundenauswahl',
    COCKPIT = 'cockpit',
    VERTRAEGE = 'vertraege',
    BUERGSCHAFTEN = 'buergschaften',
    DOWNLOADS = 'downloads',
    BENUTZERVERWALTUNG = 'benutzerverwaltung',
    POSTEINGANG = 'posteingang',
    MYDATA = 'mydata',
    MEINEDATEN = 'meinedaten',
    KUNDENDATEN = 'kundendaten',

    FIRMENVERBUENDE = 'firmenverbuende',
    ERHALTENE_ZUGRIFFE = 'erhalteneZugriffe',
    ZUGRIFFE_VERWALTEN = 'zugriffeVerwalten',

    KREDIT_PORTAL_COCKPIT = 'kreditportal/cockpit',
    KREDIT_PORTAL_KUNDENAUSWAHL = 'kreditportal/kundenauswahl',
    KREDIT_PORTAL_VERTRAEGE = 'kreditportal/vertraege',
    KREDIT_PORTAL_BUERGSCHAFTEN = 'kreditportal/buergschaften',
    KREDIT_PORTAL_DOWNLOADS = 'kreditportal/downloads',
    KREDIT_PORTAL_BENUTZERVERWALTUNG = 'kreditportal/benutzerverwaltung',
    KREDIT_PORTAL_POSTEINGANG = 'kreditportal/posteingang',
    KREDIT_PORTAL_MYDATA = 'kreditportal/mydata',
    KREDIT_PORTAL_MEINEDATEN = 'kreditportal/meinedaten',
    KREDIT_PORTAL_KUNDENDATEN = 'kreditportal/kundendaten',
    KREDIT_PORTAL_FIRMENVERBUENDE = 'kreditportal/firmenverbuende',

    SUB_PAGE = ':subPage',

    PROFILE = 'profil',
    FREI = 'frei',

    // New Authentication
    LOGIN = 'login',
    LOGOUT = 'logout',

}

export class RouteHelper {

    /** Ersetze multiple Slashes durch ein Slash, aber nicht für http(s):// vorne:
     * http://localhost:4200//web/bla -> http://localhost:4200/web/bla*/
    private static readonly MULTIPLE_SLASHES = /(?<!:)\/\/+/g;

    static joinPath(...params: (RouteNames | string)[]): string {
        return params.join('/').replaceAll(this.MULTIPLE_SLASHES, '/');
    }

}
